import {RouteGroupEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";

export type BaseRouteGroupMultiSelectProps = BaseEntityMultiSelectProps<RouteGroupEntity>;

export const BaseRouteGroupMultiSelect = (props: BaseRouteGroupMultiSelectProps) => {
  return <BaseEntityMultiSelect {...props} />;
};
